import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { pointActions } from '../../store/modules/point';
import PointIssueHistoryDetailWrap from '../../views/point/issueHistory/detail/PointIssueHistoryDetailWrap';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { POINT_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL } from '../../store/modules/point/models';

class PointIssueHistoryDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (pointIssueHistoryId) => {
    const { getPointIssueHistoryDetail } = this.props;

    getPointIssueHistoryDetail({
      pointIssueHistoryId,
      /**
       *  필터 옵션
       */
      filterOption: POINT_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  /**
   *  포인트 발급 이력에 걸린 포인트 로그 리스트 가져오기
   */
  getPointIssueHistoryPointLogList = (data) => {
    const { getPointIssueHistoryPointLogList, pointIssueHistoryDetail } = this.props;
    const { pointIssueHistoryInfo, pointIssueHistoryItemList } = pointIssueHistoryDetail;
    const { filterOption, pagination } = pointIssueHistoryItemList;

    getPointIssueHistoryPointLogList({
      pointIssueHistoryId: pointIssueHistoryInfo.pointIssueHistoryId,
      filterOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { pointIssueHistoryDetail, pointCauseSelectList } = this.props;

    return (
      <PointIssueHistoryDetailWrap
        pointCauseSelectList={pointCauseSelectList}
        pointIssueHistoryDetail={pointIssueHistoryDetail}
        getPointIssueHistoryPointLogList={this.getPointIssueHistoryPointLogList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pointIssueHistoryDetail: state.point.pointIssueHistoryDetail,
    pointCauseSelectList: state.point.pointCauseSelectList,
  };
};

const mapDispatchToProps = {
  getPointIssueHistoryDetail: pointActions.getPointIssueHistoryDetail,
  getPointIssueHistoryPointLogList: pointActions.getPointIssueHistoryPointLogList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PointIssueHistoryDetailContainer));
